// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/**
 * @apiName 获取车辆列表
 * @apiUrl
 */
export function getCarList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/list',
    method: 'POST',
    data,
  })
}

// 客户列表查询接口
export function getCustomerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 各类型的车总数
 * @apiUrl
 */
export function getCarSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/summary/getCarState',
    method: 'POST',
    data,
  })
}
// 车务状态的列表统计
export function getCarOperationState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/summary/getCarOperationState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取城市列表
 * @apiUrl
 */
export function getCityList() {
  return request({
    url: '/admin/v1/vehicle/common/cityList',
    method: 'get',
    params: {},
  })
}


/**
 * @apiName 获取车源方(服务商列表查询接口)
 * @apiUrl
 */
export function getCarProvider(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 所属车管(用户列表)
 * @apiUrl
 */
export function getCarTubeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/vehicleManagerList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取车型
 * @apiUrl
 */
export function getCarModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/modelIdAndName',
    method: 'POST',
    data,
  })
}
// 车辆标签查询
export function getCarLabelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新获取车型 申立新08/10 22：30
 * @apiUrl
 */
export function getAllCarModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/listAll',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 获取驾驶证信息
 * @apiUrl
 */
export function getDrivingInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/vehicleLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 网约车证
 * @apiUrl
 */
export function getRideHailing(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/rideHailingTransportLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 网约车证
 * @apiUrl
 */
export function getNewwork(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/driverHailingLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 获取登记证信息
 * @apiUrl
 */
export function getRegistration(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/vehicleRegCert',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增车辆
 * @apiUrl
 */
export function addCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/add',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 修改车辆
 * @apiUrl
 */
export function editCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/update',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 车辆详情
 * @apiUrl
 */
export function getCarDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/detail',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 退出运营/恢复运营状态
 * @apiUrl
 */
export function updateOperateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/updateState',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 获取出入库列表
 * @apiUrl
 */
export function getOutInList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/list',
    method: 'POST',
    data,
  })
}

// 出入库详情
export function getOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/details',
    method: 'POST',
    data,
  })
}

// 获取出入库详情提交确认未捕获到的部分信息
export function getTempOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/getStockInfo',
    method: 'POST',
    data,
  })
}


// 添加出入库记录
export function addOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/add',
    method: 'POST',
    data,
  })
}

// 新增出入库记录查询车辆 合同接口
export function getCarAndContractData(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/addCarAndContractData',
    method: 'POST',
    data,
  })
}

// 编辑出入库记录
export function editOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/update',
    method: 'POST',
    data,
  })
}

// 获取合同列表
export function getContractList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/list',
    method: 'POST',
    data,
  })
}

// 获取日志列表
export function getLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operationLog/list',
    method: 'POST',
    data,
  })
}

// 采购订单列表
export function getPurchaseOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/purchase/order/list',
    method: 'POST',
    data,
  })
}

// 企业租赁订单列表
export function getLeaseOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/lease/order/list',
    method: 'POST',
    data,
  })
}

// 车辆采购信息列表
export function getCarPurchaseOrderInfoList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/purchase/order/info/list',
    method: 'POST',
    data,
  })
}

// 采购订单信息 || 企业租赁订单信息
// export function getPurchaseOrderDetail (data = {}) {
//   return request({
//     url: '/admin/v1/vehicle/car/stockLog/order/detail',
//     method: 'POST',
//     data
//   })
// }

//
export function carVehicleImport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/import',
    method: 'POST',
    data,
  })
}

// 驾驶证OCR识别
export function ocrDriverLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/driverLicense',
    method: 'POST',
    data,
  })
}

// 设为备车-取消备车
export function readyLease(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/readyLease',
    method: 'POST',
    data,
  })
}

// 查询待租标准
export function getCarRentStandardList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/list',
    method: 'POST',
    data,
  })
}

// 编辑待租标准
export function setCarRentStandardEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/edit',
    method: 'POST',
    data,
  })
}

// 提交待审核
export function getcarAuditRecord(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/submit',
    method: 'POST',
    data,
  })
}
// 提交审核结果
export function getcarResult(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/update',
    method: 'POST',
    data,
  })
}

// 车辆相关审核开关
export function getCarInfoAuditSwitch(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRule/list',
    method: 'POST',
    data,
  })
}

// 编辑车辆相关审核开关
export function setCarInfoAuditSwitch(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRule/edit',
    method: 'POST',
    data,
  })
}


// 车辆相关审核列表
export function getCarInfoAuditList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/page',
    method: 'POST',
    data,
  })
}

/// 提交并审核代码
export function updateAndSubmit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/updateAndSubmit',
    method: 'POST',
    data,
  })
}
// 车辆相关审数量统计
export function getCarInfoAuditSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/summary',
    method: 'POST',
    data,
  })
}

// 车辆审核详情
export function getCarAuditRecordDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/detail',
    method: 'POST',
    data,
  })
}

// 车辆提交审核结果
export function carSubmitAuditStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/update',
    method: 'POST',
    data,
  })
}

// tab页数量统计
export function getStockLogSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/summary',
    method: 'POST',
    data,
  })
}

// 获取最新的出入库信息
export function stockLogFindLastOne(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/findLastOne',
    method: 'POST',
    data,
  })
}
// 获取产权方列表
export function propertyOwnerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

// 查询车辆状态接口
export function getVehicleState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/state/getVehicleState',
    method: 'POST',
    data,
  })
}

// 根据车牌号查询车辆id
export function getCarInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/getCarInfo',
    method: 'POST',
    data,
  })
}

//  新增企业租赁订单
export function AddleaseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add',
    method: 'POST',
    data,
  })
}

// 企业订单新增租赁车辆
export function addleaseOrderCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add/car',
    method: 'POST',
    data,
  })
}

// 个人租赁订单详情 + 相关事故、维保状态、违章状态 数量
export function orderDetailAndMore(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/modeConversion/detail',
    method: 'POST',
    data,
  })
}

// 审批任务详情
export function getApprovalTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getApprovalTaskDetail',
    method: 'POST',
    data,
  })
}
